export default __webpack_public_path__ + "static/media/constructor.29d41348.svg";